module.exports = __webpack_public_path__ + "static/media/Gothitelle_gaussian2.6d63bc60.png";